import { Heart, UserPlus, MessageCircle, AtSign, Tag, Sparkles } from 'lucide-react';
import { NOTIFICATIONS, getUserById } from '@/shared/data';
import { Avatar } from '@/shared/ui/Avatar';
import { formatRelativeTime } from '@/shared/utils/format';

const ICONS = {
  like: <Heart className="w-3 h-3 text-rose-300" />,
  follow: <UserPlus className="w-3 h-3 text-rose-300" />,
  comment: <MessageCircle className="w-3 h-3 text-rose-300" />,
  mention: <AtSign className="w-3 h-3 text-rose-300" />,
  tag: <Tag className="w-3 h-3 text-rose-300" />,
  // Creator-activity-burst notifications use a sparkle to distinguish them
  // from per-interaction notifications.
  post: <Sparkles className="w-3 h-3 text-rose-300" />,
};

function groupByDate(items: typeof NOTIFICATIONS) {
  const today: typeof NOTIFICATIONS = [];
  const week: typeof NOTIFICATIONS = [];
  const earlier: typeof NOTIFICATIONS = [];
  const now = Date.now();
  for (const n of items) {
    const age = now - new Date(n.createdAt).getTime();
    if (age < 24 * 60 * 60_000) today.push(n);
    else if (age < 7 * 24 * 60 * 60_000) week.push(n);
    else earlier.push(n);
  }
  return { today, week, earlier };
}

export function Notifications() {
  const { today, week, earlier } = groupByDate(NOTIFICATIONS);
  return (
    <div data-testid="instaflix-notifications" className="px-4">
      <h1 className="font-serif italic text-2xl text-white mb-4">Activity</h1>
      {[
        { label: 'Today', items: today },
        { label: 'This week', items: week },
        { label: 'Earlier', items: earlier },
      ]
        .filter((g) => g.items.length > 0)
        .map((g) => (
          <section key={g.label} className="mb-6">
            <h2 className="text-[11px] uppercase tracking-widest text-white/40 mb-2">
              {g.label}
            </h2>
            <ul className="space-y-3">
              {g.items.map((n) => {
                const actor = getUserById(n.actorId);
                return (
                  <li key={n.id} className="flex items-center gap-3">
                    <div className="relative">
                      <Avatar
                        src={actor?.avatar ?? ''}
                        alt={actor?.username ?? ''}
                        size={40}
                      />
                      <span className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full bg-velvet flex items-center justify-center border border-white/10">
                        {ICONS[n.kind]}
                      </span>
                    </div>
                    <div className="flex-1 text-sm text-white/80">{n.text}</div>
                    <div className="text-[10px] text-white/40 uppercase tracking-wider">
                      {formatRelativeTime(n.createdAt)}
                    </div>
                  </li>
                );
              })}
            </ul>
          </section>
        ))}
    </div>
  );
}
